export default __webpack_public_path__ + "static/media/noun-freighter-496203.37fd54b3.svg";